import axios, { AxiosInstance } from "axios";

const axiosRequest: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DOMAIN,
  headers: {
    //
  },
});
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  },
);
export default axiosRequest;
